import { LitElement, html, css, TemplateResult } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { EtaDeviationWarningsTable } from '../types/voyage-dialog-popup-eta-deviation-warning.types';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';

@customElement('voyage-dialog-popup-eta-deviation-popup-warning')
export class VoyageDialogPopupEtaDEviationPopupWarning extends LitElement
{
    @property({ attribute: false }) icon: TemplateResult | HTMLElement = html``;
    @property({ attribute: false  }) warningSummary: string = "";
    @property({ attribute: false  }) warnings: EtaDeviationWarningsTable[] = [];

    static get styles() {
        return [
            css`
                .container {
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: 713px;
                    padding: 20px 40px 20px 40px;
                    background: var(--neutrals-grey-10);
                    font-family: 'MaerskText';
                    font-size: 14px;
                }

                .warning-icon {
                    place-content: center;
                    fill: var(--voyage-error-red);
                    display: grid;
                    margin-bottom: 20px;
                }

                .warning-icon > svg {
                    width: 41px; 
                    height: 37px;
                }

                .warning-summary {
                    text-align: center;
                    color: var(--neutrals-grey-02);
                    margin-bottom: 16px;
                    font-size: 14px;
                }

                .description {
                    place-content: center;
                    padding: 20px;
                    border-radius: 4px;
                }

                .description-background {
                    background: var(--voy-alert-message-background-color);
                    border: 1px solid var(--voyage-error-red);
                }

                .description-center {
                    text-align: center;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                }

                th, td {
                    padding: 10px;
                    border: 1px solid var(--neutrals-grey-02);
                    text-align: left;
                }

                th {
                    background-color: var(--neutrals-grey-10);
                    color: var(--neutrals-grey-02);
                }

                tr:nth-child(even) {
                    background-color: var(--neutrals-grey-07);
                }

                .wp-container {
                    position: relative;
                    text-align: center;
                }

                .wp-number {
                    display: block;
                }

                .custom-pilot-icon {
                    position: absolute;
                    left: 8%;
                    top: 61%;
                    transform: translateY(-50%);
                }
            `
        ];
    }

    render()
    {
        return html`
            <div class="container">
                <div class="warning-icon">${this.icon}</div>
                <div class="warning-summary">${this.warningSummary}</div>
                ${this._renderTable()}
            </div>
        `;
    }

    private _renderTable() {
        return html`
            <table>
                <thead>
                    <tr>
                        <th>Waypoint #</th>
                        <th>Requested ETA</th>
                        <th>Actual ETA</th>
                        <th>Coordinates</th>
                    </tr>
                </thead>
                <tbody>
                    ${this.warnings.map(warning => html`
                        <tr>
                            <td>
                                <div class="wp-container">
                                    ${warning.isPilot ? html`<span class="custom-pilot-icon">${SvgIcons.customPilotIcon}</span>` : ""}
                                    <span class="wp-number">${warning.wpNumber}</span>
                                </div>
                            </td>
                            <td>${warning.RequestedEta}</td>
                            <td>${warning.ActualEta}</td>
                            <td>${warning.Coordinates}</td>
                        </tr>
                    `)}
                </tbody>
            </table>
        `;
    }
}
